import { MenuTextMatch } from '@lexical/react/LexicalTypeaheadMenuPlugin';

export const lexicalTypeaheadMenuTriggerFn = (textBeforeCursor: string): MenuTextMatch | null => {
  const open = textBeforeCursor.lastIndexOf('{{');
  if (open === -1) {
    return null;
  }

  const close = textBeforeCursor.lastIndexOf('}}');
  if (close !== -1 && close > open) {
    return null;
  }

  return {
    leadOffset: open,
    matchingString: textBeforeCursor.slice(open + 2),
    replaceableString: textBeforeCursor.slice(open),
  };
};
